<template>
    <div v-if="userInfoLoaded">
        <files-recently-added></files-recently-added>
        <b-row class="my-5">
            <b-col md="4">
                <b-row class="text-center action-wrapper">
                    <b-col md="6">
                        <b-btn
                            v-if="$can('import products')"
                            @click="showProductImportDialog = true"
                            variant="primary"
                            class="btn-round mb-2 mb-md-0 mr-md-2"
                            >{{ $t("import_products") }}</b-btn
                        >
                        <collection-dialog
                            @saved="triggerReloads"
                            v-model="showCollectionDialog"
                        />
                    </b-col>

                    <b-col md="6">
                        <b-button
                            v-if="$can('create collection')"
                            @click="showCollectionDialog = true"
                            class="btn-round"
                            >{{ $t("create_collection") }}</b-button
                        >
                    </b-col>
                </b-row>
                <search-product></search-product>
            </b-col>
            <b-col md="8">
                <product-list></product-list>
            </b-col>
        </b-row>
        <product-importer v-model="showProductImportDialog"></product-importer>
    </div>
</template>

<script>
import FilesRecentlyAdded from "./RecentlyAdded";
import SearchProduct from "./Search";
import ProductList from "./ProductList";
import CollectionDialog from "./EditDialogs/CollectionDialog";

import { mapActions } from "vuex";
import ProductImporter from "./ProductImporter";

export default {
  components: {
    ProductImporter,
    CollectionDialog,
    ProductList,
    SearchProduct,
    FilesRecentlyAdded
  },
  data() {
    return {
      showCollectionDialog: false,
      userInfoLoaded: false,
      showProductImportDialog: false
    };
  },
  methods: {
    triggerReloads() {
      this.search();
    },
    ...mapActions("smartVaultSearch", ["search"]),
    ...mapActions("me", ["getMe"])
  },
  mounted() {
    this.getMe().then(() => {
      this.userInfoLoaded = true;
    });
  }
};
</script>

<style scoped>
</style>
